'use strict';
import actionTypes from '../actionTypes';

const initialState = {
    blogs: null,
    blog: null,
    parentBlog: null
};

function blogReducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.SET_CURRENT_BLOG:
            return {
                ...state,
                blog: action.payload
            };
            // eslint-disable-next-line no-unreachable
            break;
        case actionTypes.SET_PARENT_BLOG:
            return {
                ...state,
                parentBlog: action.payload
            };
            // eslint-disable-next-line no-unreachable
            break;
        default:
            return state;
    }
}

export { blogReducer };

export default {
    blogReducer: blogReducer
};
